export const SITE = {
  name: "TMV Coffee",
  full: "TMV Coffee – The Modern Village Coffee",
  statement:
    "Premium filter coffee and tea from the heart of Tamil Nadu — roasted in small batches, blended with care, and poured into every memory.",
  // Single source of truth — replace with the real WhatsApp number (digits only, with country code).
  whatsappNumber: "918667718386",
  whatsappDisplay: "+91 86677 18386",
  phone: "+91 86677 18386",
  email: "hello@tmvcoffee.com",
  address: "The Modern Village, Chennai, Tamil Nadu",
  instagram: "https://instagram.com/tmvfoods",
  facebook: "https://facebook.com/tmvcoffee",
};

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const scrollToHash = (hash) => {
  const el = hash && document.querySelector(hash);
  if (!el) return false;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
  return true;
};

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/080d28e333c2fb3f53e5116deb9355075bebfe6d96a88f1c6aef812f749e528f.jpeg",
  heroFilm2:
    "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/7dd7775e58f82b6b51d4a8631164d63e220154c1ce0a1676e0bd89c16d570876.jpeg",
  heroFilm3:
    "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/da2a8ce9f9c0c6a4f87cb3b3e3320577a1e2a0f699a1ec4da844e134f7550935.jpeg",
  storyBeans:
    "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/7f92e87b089e237f92e6a93454731de01622181805d542088825abbcb5c4f6ff.jpeg",
  storyFilter:
    "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/756689be8fb9debf5923670168e0ee485a2149e4874ea1c1546633830b669574.jpeg",
  storyBrewed:
    "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/87fab1ccd7d31a798dce7962febb89d8d0966f1b65492734f2bb6c76251bac20.jpeg",
  storyEnjoying:
    "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/f0268f4b9918c78abe8944da8e420e31a5d49134da3aa12a9304b0240eb3b4c2.jpeg",
  storyBeans2:
    "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/7a4e384cf7e505dc22d84abf97b11120585e3b682229ac60966d3e4ac700ef51.jpeg",
  storyFilter2:
    "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/4b1b07bce086bd4f4a9d70be8d2ae3b2c0890a8508c17f416a73b8ca52738d3b.jpeg",
  storyBrewed2:
    "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/8cde058087f61e444b66f410dc6be1771135a2c5f6f740efebb3a4980cd80f79.jpeg",
  storyEnjoying2:
    "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/ea163960a94bf6c10edb22ad3f462aa2bc363d18bb09797ec5099b0822f2e66a.jpeg",
  experienceEvening:
    "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/eb543b191404d5d54ea2b8a77ccaa659a970fe2bc949ffb4a09beb1e82f4319d.jpeg",
  friends:
    "https://images.unsplash.com/photo-1582298538104-fe2e74c27f59?q=85&w=1200&auto=format&fit=crop",
  eveningCup:
    "https://images.unsplash.com/photo-1543233604-3baca4d35513?q=85&w=1200&auto=format&fit=crop",
  instaCup:
    "https://images.unsplash.com/photo-1506619216599-9d16d0903dfd?q=85&w=900&auto=format&fit=crop",
  instaFriends:
    "https://images.unsplash.com/photo-1653762378429-8030175fda56?q=85&w=900&auto=format&fit=crop",
  instaPair:
    "https://images.unsplash.com/photo-1653762381632-2945469edb7b?q=85&w=900&auto=format&fit=crop",
  instaSteps:
    "https://images.unsplash.com/photo-1758525863581-50540e84f868?q=85&w=900&auto=format&fit=crop",
};
